module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chaptitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }), _c('b', [_vm._v("MAPS")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ch01#rfig1",
      "id": "fig1"
    }
  }, [_vm._v("Figure 1.  The Confederate Trans-Mississippi")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch05#rfig2",
      "id": "fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2.  Union and Confederate Lines of March during the Prairie Grove Campaign, December 3–December 6, 1862")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch05#rfig3",
      "id": "fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.  The Battle of Prairie Grove, December 7, 1862")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch06#rfig4",
      "id": "fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.  Marmaduke’s First Missouri Raid")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch06#rfig5",
      "id": "fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5.  Marmaduke’s Cape Girardeau Raid")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch06#rfig6",
      "id": "fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6.  Shelby’s Missouri Raid")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch06#rfig7",
      "id": "fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.  Price’s Missouri Expedition")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ec34fed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maps.vue
// module id = 81
// module chunks = 0